<script>
	export let color = 'white';
</script>

<svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M12.2499 2.75537C6.9459 2.75537 2.6499 7.05137 2.6499 12.3554C2.6499 17.6594 6.9459 21.9554 12.2499 21.9554C17.5539 21.9554 21.8499 17.6594 21.8499 12.3554C21.8499 7.05137 17.5539 2.75537 12.2499 2.75537ZM11.5119 17.9474H9.9039L6.0159 12.4994L7.6251 10.9994L10.7079 13.8794L16.8771 6.76217L18.4851 7.89017L11.5119 17.9474V17.9474Z"
		fill={color}
	/>
</svg>
